










































import Vue from 'vue';
import UserForm from './components/UserForm.vue'
import { getUsers,postUser,deleteUsers } from '../../modules/user/user.service';
import { UserRoles } from '../../modules/auth/auth.model';

export default Vue.extend({
  data() {
    return {
      search: '',
      expanded: [],
      msgSuccess1: '',
      msgError1: '',
      msgSuccess2: '',
      msgError2: '',
      msgSuccess3: '',
      msgError3: '',
      userData: {
        firstName:'',
        lastName:'',
        email:'',
        password:'',
        role:'',
        sites: []
      },
      categoryDataToUpdate: {
        name:'',
        description:''
      },
      selectedLines: [],
      tableHeaders: [
        {
          text: 'Nom',
          align: 'start',
          sortable: false,
          value: 'user.lastName',
        },
        { text: 'Prénom', value: 'user.firstName' },
        { text: 'Email', value: 'user.email' },
        { text: 'Role', value: 'user.role' },
        { text: 'Sites', value:'user.sitesNamesConcat' },
        { text: 'Actions', value: 'actions' }
        
      ],
      userList: [],
      isUser: false,
      isSiteManager: false,
      isAdmin: false
    }
  },
  components: {
    UserForm
  },
  mounted() {
    this.getUsersList();
    const role = localStorage.getItem('user-role');
    if (role === UserRoles.SITEMNGR.key){
      this.isSiteManager = true;
    }else if (role === UserRoles.ADMIN.key){
      this.isAdmin = true;
    }else if (role === UserRoles.USER.key){
      this.isUser = true;
    }
  },
  methods: {
    getUsersList(){
      getUsers().then(res=>{
        if (res.data){
          this.userList = res.data;
          for (const userSite of res.data) {
            let siteNamesString = '';
            if (userSite.sites && userSite.sites.length > 0){
              for (const site of userSite.sites) {
                siteNamesString += (siteNamesString=='')?site.name:',\r\n'+site.name;
              }
              }
            userSite.user.sitesNamesConcat = siteNamesString;
          }
        }else if (res.error){
          this.msgError1 = 'Error en el envio de la categoria.'
        }
      });
    },
    deleteSelectedUser(){
      this.msgSuccess2 = '';
      this.msgError2= '';
      deleteUsers(this.selectedLines).then(res=>{
        if(res.data){
          if(res.data.successData.length > 0){
            this.msgSuccess2 = res.data.successData.length+' utilisateurs ont été supprimés.';
          }
        }

        if(res.error){
          if(res.error.errorData.length > 0){
            this.msgError2 = res.error.errorData.length+' utilisateurs en erreur n\'ont pas été supprimés.';
          }
        }
        this.selectedLines = [];
        this.getUsersList();
      });
    }
  }
})
